import { render, staticRenderFns } from "./DashboardPillarLabel.vue?vue&type=template&id=1bacf07a&scoped=true&lang=html&"
import script from "./DashboardPillarLabel.vue?vue&type=script&lang=js&"
export * from "./DashboardPillarLabel.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPillarLabel.vue?vue&type=style&index=0&id=1bacf07a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bacf07a",
  null
  
)

export default component.exports